import { DEFAULT_THEME_ID, getThemeById, THEME_STORAGE_KEY } from '@/config/theme'

function setVar(name, value) {
  document.documentElement.style.setProperty(name, value)
}

export function applyTheme(themeId) {
  const theme = getThemeById(themeId || DEFAULT_THEME_ID)
  const root = document.documentElement
  root.setAttribute('data-theme', theme.id)
  setVar('--gas-primary', theme.primary)
  setVar('--gas-primary-light', theme.primaryLight)
  setVar('--gas-primary-dark', theme.primaryDark)
  setVar('--gas-primary-hover', theme.primaryHover)
  setVar('--gas-sidebar-from', theme.sidebarFrom)
  setVar('--gas-sidebar-to', theme.sidebarTo)
  setVar('--gas-sidebar-text', theme.sidebarText)
  setVar('--gas-sidebar-active-bg', theme.sidebarActiveBg)
  setVar('--gas-sidebar-active-text', theme.sidebarActiveText)
  setVar('--gas-header-from', theme.headerFrom)
  setVar('--gas-header-to', theme.headerTo)
  setVar('--gas-layout-bg', theme.layoutBg)
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme.id)
  } catch (e) {
    /* ignore */
  }
  return theme
}

export function loadStoredTheme() {
  let id = DEFAULT_THEME_ID
  try {
    id = localStorage.getItem(THEME_STORAGE_KEY) || DEFAULT_THEME_ID
  } catch (e) {
    /* ignore */
  }
  return applyTheme(id)
}

export function getStoredThemeId() {
  try {
    return localStorage.getItem(THEME_STORAGE_KEY) || DEFAULT_THEME_ID
  } catch (e) {
    return DEFAULT_THEME_ID
  }
}
